@if (allowed()) {
  <p-button class="" [styleClass]="className()" (onClick)="handleClick()" [disabled]="disable()">
      @if (showIcon() && iconPosition() === 'before') {
        <i class="icon {{ iconClass() }}"></i>
      }
    <!-- @if(!showSpinner()) { -->
      @if(label() !== '') {
        <span class="">{{ label() | translate }}</span>
      }
    <!-- } -->
    <!-- @else if (showSpinner()) {
        <p-progress-spinner strokeWidth="8" fill="transparent" [style]="{ width: '50px', height: '50px' }" [ngStyle]="{ 'stroke': '#1976d2' }"></p-progress-spinner>
    } -->
    @if (showIcon()&& iconPosition() === 'after') {
      <i class="icon {{ iconClass() }}"></i>
    }
  </p-button>
}